import { render, staticRenderFns } from "./DashboardClientSecret.vue?vue&type=template&id=42075bbf&"
import script from "./DashboardClientSecret.vue?vue&type=script&lang=ts&"
export * from "./DashboardClientSecret.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42075bbf')) {
      api.createRecord('42075bbf', component.options)
    } else {
      api.reload('42075bbf', component.options)
    }
    module.hot.accept("./DashboardClientSecret.vue?vue&type=template&id=42075bbf&", function () {
      api.rerender('42075bbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientDashboard/DashboardClientSecret.vue"
export default component.exports